import { PROVINCE_CALCULATOR_DATA } from '../constants/province-data';
import { CalculatorProvince } from '../types/calculator';
import { SubdivisionCodeValue } from '../config';

/**
 * Convert subdivision code to province code (CA-ON → ON)
 */
export const getProvinceCodeFromSubdivision = (subdivisionCode: string): string => {
  if (subdivisionCode.startsWith('CA-')) {
    return subdivisionCode.substring(3);
  }
  return subdivisionCode;
};

/**
 * Convert API subdivision data to calculator province format
 */
export const convertToCalculatorProvince = (subdivision: SubdivisionCodeValue): CalculatorProvince => {
  const provinceCode = getProvinceCodeFromSubdivision(subdivision.code);
  const calculatorData = PROVINCE_CALCULATOR_DATA[provinceCode] || PROVINCE_CALCULATOR_DATA["ON"];
  
  return {
    id: provinceCode,
    subdivisionId: subdivision.id,
    code: subdivision.code,
    name: subdivision.text,
    text: subdivision.text,
    description: subdivision.description,
    sortOrder: subdivision.sortOrder,
    ...calculatorData
  };
};

/**
 * Get default province structure for Ontario (fallback)
 */
export const getDefaultOntarioProvince = (): CalculatorProvince => ({
  id: "ON",
  subdivisionId: 600,
  code: "CA-ON",
  name: "Ontario",
  text: "Ontario", 
  description: "Ontario",
  sortOrder: 1,
  ...PROVINCE_CALCULATOR_DATA["ON"]
}); 